// import * as React from 'react';
import { styled } from '@mui/material/styles';
import { FormControl, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDisease, getDisease } from '../../reducer/diseaseSlice';

const FormControlCss = styled(FormControl)({
    '& .MuiFilledInput-root': {
        height: '35px',
        borderColor: 'rgba(0, 0, 0, 0)',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: '0px',
        '&:before': {
            borderBottom: 'none'
        },
        '& fieldset': {
            borderColor: 'rgba(0, 0, 0, 0)',
            backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        '&:hover': {
            borderBottomStyle: 'none',
            backgroundColor: 'rgba(255, 0, 0, 0)',
        },
        '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottomStyle: 'none',
            backgroundColor: 'rgba(255, 0, 0, 0)',
        },
        '&.Mui-focused': {
            // borderColor: 'rgba(0, 0, 0, 0)',
            backgroundColor: 'rgba(0, 0, 0, 0)',
        },
    }
})

const CssSelect = styled(Select)({
    '& label.Mui-focused': {
        color: 'rgba(255, 0, 0, 0.5)',
    },
    '& .MuiFilledInput-input': {
        color: 'black',
        padding: '0px 0px 0px 5px',
        '&:focus': {
            backgroundColor: 'rgba(255, 0, 0, 0)',
            borderBottomStyle: 'none'
        }
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'red',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'rgba(255, 0, 0, 1)',
        },
        '&:hover fieldset': {
            borderColor: 'rgba(255, 0, 0, 1)',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'rgba(255, 0, 0, 1)',
        },
    },
    '& .MuiSvgIcon-root': {
        color: 'black'
    }
});

const menuList = [
    {
    value: "1",
    text: "ไข้เลือดออก"
    }, 
    // {
    //     value: "2",
    //     text: "มาลาเรีย"
    // }
]

function DiseaseList() {
    const disease = useSelector(getDisease);
    const dispatch = useDispatch();
    // console.log(disease);
    const [diseaseSelected, setDiseaseSelected] = useState(disease);

    const handleChange = (event) => {
        const value = event.target.value;
        setDiseaseSelected(value);
        dispatch(setDisease(value));
    }

    return (
        <>
            <FormControlCss
                variant="filled"
                sx={{
                    // flexGrow: 1,
                    position: 'absolute',
                    width: 'calc(100% - 48px)',
                    alignItems: 'center'
                }}
            >
                <CssSelect
                    id="demo-simple-select"
                    value={diseaseSelected}
                    sx={{
                        width: '200px'
                    }}
                    onChange={handleChange}
                >
                    {
                        menuList.map((data, index) => (
                            <MenuItem key={index} value={data.value}>{data.text}</MenuItem>
                        ))
                    }
                </CssSelect>
            </FormControlCss>
        </>
    )
}

export default DiseaseList;